import React, { useState } from 'react';
import MainContainer from '../../../components/MainContainer';
import { headerDataImmo } from '../../../data/modules/logistic-header';
import { AppBar, Grid } from '@mui/material';
import { AntTab, AntTabs } from '../../../components/ant-tab';
import IndemnityMissionTable from './IndemnityMissionTable';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
   
    tab: {
      width: "50%",
    },
    AppBar: {
      borderRadius: "8px",
      boxShadow: "rgba(0, 0, 0, 0.1) 0px 4px 12px",
    },
  }));

const IndemnityMissionList = () => {
    const [value, setValue] = useState(0);
    const classes = useStyles();

    const handleChange = (event, newValue) => {
    };

    return (
        <MainContainer {...headerDataImmo}>
        <Grid container spacing={2} >
        {value === 0 && (
        <Grid item xl={12} md={12} pt={2}>
              <IndemnityMissionTable />
        </Grid>
      )}
        </Grid> 

        </MainContainer>
    );
}

export default IndemnityMissionList;